import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import designsSummaryLoaded from './designsSummaryLoaded';

const actions = {
  [types.DESIGNS_SUMMARY_LOADED]: designsSummaryLoaded,
};

const initialState = {
  designs: [],
};

export default (state = initialState, action) => (actions[action.type] || identity)(state, action);
